// extracted by mini-css-extract-plugin
export default {"courseItem":"CourseItem_courseItem__Dirq4","buttons":"CourseItem_buttons__LlWPR"};